import { MenuItem, Select, TextField, Typography } from "@material-ui/core";
import { TemplateProps } from "../../journeys/journey/Interfaces";
import { Button, Cards, CustomIcon, MaskedTextField } from "ams-ui-reactkit";
import DynamicHtml from "../../molecules/DynamicHtml";
import "./MovingProtection.scss";
import { TitleBlock } from "../../atoms";
import { useRef, useState } from "react";
import { SignatureCard } from "../../molecules";
import { useContextSelector } from "@fluentui/react-context-selector";
import { StoreContext } from "../../context";
import { calculateBase64SignSize } from "../../utils/Utils";
import { navigate } from "@reach/router";
import { actionTypeConstants } from "../../utils";
import { useEffect } from 'react';
import moment from 'moment';

const MovingProtection: React.FC<TemplateProps> = (props: any) => {
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const customerInfoState: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);
    const { templateProps } = props;
    console.log("templateProps:", templateProps);
    const { title, subtitle, data } = templateProps;

    const [signDate, setSignDate] = useState(new Date());
    const [selectedNo, SetSelectedNo] = useState(customerInfoState?.FVPOption || 0);
    const [selectedValue, setSelectedValue] = useState(customerInfoState?.CustomerSelected); // default
    const [minimumValue, setMinimumValue] = useState(customerInfoState?.MinimumValue); // default
    const [currentTarrifRate, setCurrentTarrifRate] = useState(data[selectedNo]?.tariffRate ? data[selectedNo]?.tariffRate : 0); // default
    const [coverageCost, setCoverageCost] = useState((selectedValue / 1000) * currentTarrifRate); // default

    const [loading, setLoading] = useState(false);
    const signatures: any = customerInfoState?.Signatureurl?.[0];

    //console.log("signatures:", signatures)
    const validateSignatureBySize = (process.env.REACT_APP_VALIDATE_SIGN_BY_SIZE === "true") ? true : false;
    const validSignatureSize = 4000;

    const [invalidCustomerSignMessage, setInvalidCustomerSignMessage] = useState("");

    const [customerSign, setCustomerSign] = useState<any>(signatures?.getUrl || "");
    const customerSignRef = useRef<SignaturePad>(null);
    //alert(customerInfoState?.CustomerSelected)
    //const minAmt = customerInfoState?.FVPOption != -1 ? customerInfoState?.CustomerSelected : data[1]?.weightDetuctible.actualWeight * data[1]?.weightDetuctible.rate;

    const [signCDate, setSignCDate] = useState(signatures?.getUrl ?
        `SIGNED ${moment(new Date(customerInfoState?.SignedDated)).format('MM/DD/YYYY HH:mm A')}` :
        customerSign ? `SIGNED ${moment(signDate).format('MM/DD/YYYY HH:mm A')}` : "")
    console.log("signCDate:", signCDate)

    const getMinOwnDeclaredAmt = (idx: number) => {

        let minAmt = 0;
        let dataObj = data.filter((item: any, index: number) => {
            return item.sno === idx
        });

        minAmt = dataObj[0]?.weightDetuctible?.actualWeight * dataObj[0]?.weightDetuctible?.rate;

        if (customerInfoState?.FVPOption != -1 && idx === customerInfoState?.FVPOption) {

            const custSelectedAmt = customerInfoState?.CustomerSelected;
            if (minAmt < custSelectedAmt) {
                console.log(idx, customerInfoState?.FVPOption, minAmt)
                return minAmt
            } else {
                console.log(idx, customerInfoState?.FVPOption, custSelectedAmt)
                return custSelectedAmt;
            }
        }
        if (minAmt < minimumValue) {
            minAmt = minimumValue;
        }
        console.log(idx, customerInfoState?.FVPOption, minAmt)
        return minAmt;
    }

    const getMaxOwnDeclaredAmt = (idx: number) => {
        let maxAmt = 60000;
        let dataObj = data.filter((item: any, index: number) => {
            return item.sno === idx
        });
        maxAmt = (dataObj[0]?.noOfTruckRequire ? dataObj[0]?.noOfTruckRequire : 1) * maxAmt;
        return maxAmt;
    }

    const minAmt = getMinOwnDeclaredAmt(1);
    const maxOwnAmtAmt = getMaxOwnDeclaredAmt(1);
    //const [ownValue, setOwnValue] = useState(data[1]?.isWeightDetuctible === true ? minAmt : 0); // default
    const [ownValue, setOwnValue] = useState(data[selectedNo]?.isWeightDetuctible === true ?
        customerInfoState?.FVPOption != -1 ? customerInfoState?.CustomerSelected : minAmt : 0);
    const [ownCoverageCost, setOwnCoverageCost] = useState(ownValue * data[selectedNo]?.weightDetuctible?.multiplier);
    const [errorMsg, setErrorMsg] = useState<any>([]);

    const getWeightOwnValue = (idx: number) => {
        let dataObj = data.filter((item: any, index: number) => {
            return item.sno === idx
        });
        if (dataObj[0]?.isWeightDetuctible === true) {
            if (customerInfoState?.FVPOption === idx) {
                return customerInfoState?.CustomerSelected;
            } else {
                return getMinOwnDeclaredAmt(idx);
            }
        } else {
            return 0;
        }
    }

    const getActualWeight = (idx: number) => {
        let dataObj = data.filter((item: any, index: number) => {
            return item.sno === idx
        });
        return dataObj[0]?.weightDetuctible?.actualWeight ? dataObj[0]?.weightDetuctible?.actualWeight : 0
    }

    const getWeightDeductibleAmount = (idx: number) => {
        let dataObj = data.filter((item: any, index: number) => {
            return item.sno === idx
        });
        return dataObj[0]?.weightDetuctible?.weightCoverageCost ? dataObj[0]?.weightDetuctible?.weightCoverageCost : 0
    }

    const defaultWeightObject: any = {
        actualWeight: 0,
        ownValue: 0,
        minAmt: 0,
        maxOwnAmtAmt: 0,
        ownCoverageCost: 0,
        errorMsg: "",
        selectedValue: 0,
        deductibleAmount: 0
    }

    const [weightObject, setWeightObject] = useState<any>([
        { ...defaultWeightObject },
        {
            ...defaultWeightObject, actualWeight: getActualWeight(1),
            minAmt: getMinOwnDeclaredAmt(1), maxOwnAmtAmt: getMaxOwnDeclaredAmt(1),
            ownValue: getWeightOwnValue(1),
            deductibleAmount: getWeightDeductibleAmount(1)
        },
        { ...defaultWeightObject },
        {
            ...defaultWeightObject, actualWeight: getActualWeight(3),
            minAmt: getMinOwnDeclaredAmt(3),
            maxOwnAmtAmt: getMaxOwnDeclaredAmt(3),
            ownValue: getWeightOwnValue(3),
            deductibleAmount: getWeightDeductibleAmount(3)
        }
    ])


    const getDeductibleSelectedValue = (sno: number) => {
        let dataObj = data.filter((item: any, idx: number) => item.sno === sno);
        if (dataObj[0]?.isDeductible === true) {
            if (customerInfoState?.FVPOption === sno) {
                return customerInfoState?.CustomerSelected;
            } else {
                return dataObj[0]?.deductible?.minimumValue;;
            }
        } else {
            return minimumValue;
        }
    }
    const getDeductibleDDLMinValue = (sno: number) => {
        let dataObj = data.filter((item: any, idx: number) => item.sno === sno);
        if (dataObj[0]?.isDeductible === true) {
            return dataObj[0]?.deductible?.minimumValue;
        } else {
            return minimumValue;
        }
    }

    const getDeductibleTarrifRate = (sno: number) => {
        let dataObj = data.filter((item: any, idx: number) => item.sno === sno);
        if (dataObj[0]?.isDeductible === true) {
            return dataObj[0]?.deductible?.tariffRate;
        } else {
            return 0;
        }
    }

    const getDeductibleAmount = (sno: number) => {
        let dataObj = data.filter((item: any, idx: number) => item.sno === sno);
        if (dataObj[0]?.isDeductible === true) {
            return dataObj[0]?.deductible?.deductibleAmount;
        } else {
            return 0;
        }
    }

    const defaultDeductibleObject: any = {
        selectedValue: 0,
        coverageCost: 0,
        deductibleAmount: 0,
        minimumValue: 0,
        tarrifRate: 0,
        errorMsg: ""
    }
    const [deductibleObject, setDeductibleObject] = useState<any>([
        { ...defaultDeductibleObject },
        {
            ...defaultDeductibleObject,
            selectedValue: getDeductibleSelectedValue(1),
            minimumValue: getDeductibleDDLMinValue(1),
            tarrifRate: getDeductibleTarrifRate(1),
            deductibleAmount: getDeductibleAmount(1)
        },
        { ...defaultDeductibleObject },
        {
            ...defaultDeductibleObject,
            selectedValue: getDeductibleSelectedValue(3),
            minimumValue: getDeductibleDDLMinValue(3),
            tarrifRate: getDeductibleTarrifRate(3),
            deductibleAmount: getDeductibleAmount(3)
        }
    ])


    useEffect(() => {
        if (!customerInfoState?.customerId) {
            navigate('/');
            return;
        }
        // if (customerInfoState.FVPOption == 1 || selectedNo == 1) {
        //     // setSelectedValue(customerInfoState?.CustomerSelected);
        //     // setCoverageCost((customerInfoState?.CustomerSelected / 1000) * currentTarrifRate)
        // }
    }, [customerInfoState])

    // useEffect(() => {
    //     setCoverageCost((selectedValue / 1000) * currentTarrifRate)
    // }, [selectedValue])

    useEffect(() => {
        calculateWeightOwnCoverageCost(1);
        calculateWeightOwnCoverageCost(3);
    }, [ownValue])

    useEffect(() => {
        // setOwnCoverageCost((ownValue * data[selectedNo]?.weightDetuctible?.multiplier))
        // validateOwnAmount(ownValue);

        calculateWeightOwnCoverageCost(selectedNo);
    }, [weightObject && weightObject[selectedNo]?.ownValue, selectedNo])

    const calculateWeightOwnCoverageCost = (sno: number) => {
        let weightObj = [...weightObject];
        if (sno == 1 || sno == 3) {
            const ownValue = weightObj[sno]?.ownValue;
            const weightDetuctibleObj: any = data.filter((item: any, idx: number) => item.sno === sno);
            const multiplier = weightDetuctibleObj[0]?.weightDetuctible?.multiplier;
            const ownCoverageCost = ownValue * multiplier;
            weightObj[sno].ownCoverageCost = ownCoverageCost;
            setWeightObject(weightObj);
        }
    }

    useEffect(() => {
        const element = document.getElementById("option_" + customerInfoState?.FVPOption);
        if (element) {
            element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    }, [])


    useEffect(() => {
        setCoverageCost((selectedValue / 1000) * currentTarrifRate)
        calculateDeductibleCoverageCost(1);
        calculateDeductibleCoverageCost(3);
    }, [selectedValue])

    useEffect(() => {
        calculateDeductibleCoverageCost(selectedNo);
    }, [deductibleObject && deductibleObject[selectedNo]?.selectedValue, selectedNo])

    useEffect(() => {
        setSignCDate(signatures?.getUrl ?
            `SIGNED ${moment(new Date(customerInfoState?.SignedDated)).format('MM/DD/YYYY HH:mm A')}` :
            customerSign ? `SIGNED ${moment(signDate).format('MM/DD/YYYY HH:mm A')}` : "")
    }, [signDate, customerSign, signatures?.getUrl])

    const calculateDeductibleCoverageCost = (sno: number) => {
        let deductibleObj = [...deductibleObject];

        if (sno == 1 || sno == 3) {
            let dataObj = data.filter((item: any, idx: number) => item.sno === sno);
            deductibleObj[sno].coverageCost = (deductibleObj[sno]?.selectedValue / 1000) * dataObj[0]?.deductible?.tariffRate;
            setDeductibleObject(deductibleObj);
        }
    }

    const handleCustomerSignEnd = (evt: any) => {
        //@ts-ignore
        const signatureSize = calculateBase64SignSize(customerSignRef?.current?.getTrimmedCanvas()?.toDataURL());

        if (validateSignatureBySize && (signatureSize <= validSignatureSize)) {
            setInvalidCustomerSignMessage("We couldn't detect a Shipper/Customer signature.");

        } else {
            // @ts-ignore
            setCustomerSign(customerSignRef?.current?.getTrimmedCanvas()?.toDataURL() || "")
            setInvalidCustomerSignMessage("");
        }
        setSignDate(new Date());
    }

    const clearCustomerSignature = async () => {
        setCustomerSign("");
        setInvalidCustomerSignMessage("");
        customerSignRef?.current?.clear();
        dispatch({
            'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
            'payload': {
                ...customerInfoState, "Signatureurl": [{
                    "getUrl": "",
                    "putUrl": customerInfoState?.Signatureurl?.[0].putUrl
                }]
            }
        })
    }

    const Title = ({ title, subtitle }: any) => {
        return <div className="singleTitleBlock">
            <Typography variant='h6' color='textPrimary' className="title" noWrap={false} align='center'>
                <DynamicHtml content={title} />
            </Typography>
            {subtitle && <Typography variant='body2' color='textPrimary' className="sub_title" noWrap={false} align='center'>
                <DynamicHtml content={subtitle} />
            </Typography>}
        </div>
    }

    const handleContinue = () => {
        //navigate(templateProps?.nextScreen || '/');
        if (customerInfoState?.isLocalJourney) {
            //only for testing
            // dispatch({
            //     'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
            //     'payload': { ...customerInfoState, "FVPOption": selectedNo }
            // })
            // navigate(templateProps?.nextScreen || '/');
            updateSelection(customerInfoState.customerId)
        } else {
            saveFVPValue();
        }
    }

    const saveFVPValue = async () => {
        setLoading(true);
        let geturl = customerInfoState?.Signatureurl[0].getUrl || "";
        if (!geturl && customerInfoState?.IsTab != 2) {
            uploadSignature(customerSign);
        } else {
            updateSelection(customerInfoState.customerId)
        }
    }

    const updateSelection = async (CID: any) => {
        console.log("customerInfoState:", customerInfoState)
        const options = customerInfoState?.options ? customerInfoState?.options : 3;
        const isWeightDetuctible = customerInfoState?.IsWeightDeductible;
        const isDetuctible = customerInfoState?.IsDeductible;
        let params = {};

        const weightObj = weightObject[selectedNo];

        if (options === 4) {
            if (isWeightDetuctible) {
                params = {
                    "CustomerId": CID,
                    "SelectedOption": selectedNo,
                    "SelectedAmmount": weightObj.ownValue,
                    // "CoverageCost": weightObj.ownCoverageCost.toFixed(2),
                    "CoverageCost": (selectedNo == 1 || selectedNo == 3) ? weightObj.ownCoverageCost.toFixed(2) : 0,
                    "CustomerSign": customerSign,
                    "IsTab": customerInfoState?.IsTab,
                    "DeductibleAmount": (selectedNo == 1 || selectedNo == 3) ? weightObj.deductibleAmount : 0,
                    "SignDate": signCDate?.toString().split(" ")[1],
                    "SignTime": signCDate?.toString().split(" ")[2] + " " + signCDate?.toString().split(" ")[3],
                }
            } else if (isDetuctible) {
                const deductibleObj = deductibleObject[selectedNo];

                params = {
                    "CustomerId": CID,
                    "SelectedOption": selectedNo,
                    "SelectedAmmount": deductibleObj.selectedValue,
                    // "CoverageCost": weightObj.ownCoverageCost.toFixed(2),
                    "CoverageCost": (selectedNo == 1 || selectedNo == 3) ? deductibleObj.coverageCost : 0,
                    "CustomerSign": customerSign,
                    "IsTab": customerInfoState?.IsTab,
                    "DeductibleAmount": isDetuctible ? deductibleObj?.deductibleAmount : 0,
                    "SignDate": signCDate?.toString().split(" ")[1],
                    "SignTime": signCDate?.toString().split(" ")[2] + " " + signCDate?.toString().split(" ")[3],
                }
            }
        } else {
            if (isWeightDetuctible) {
                params = {
                    "CustomerId": CID,
                    "SelectedOption": selectedNo,
                    "SelectedAmmount": ownValue,
                    //"CoverageCost": ownCoverageCost.toFixed(2),
                    "CoverageCost": (selectedNo == 1 || selectedNo == 3) ? ownCoverageCost.toFixed(2) : 0, //
                    "CustomerSign": customerSign,
                    "IsTab": customerInfoState?.IsTab,
                    "DeductibleAmount": 0,
                    "SignDate": signCDate?.toString().split(" ")[1],
                    "SignTime": signCDate?.toString().split(" ")[2] + " " + signCDate?.toString().split(" ")[3],
                }
            } else {
                params = {
                    "CustomerId": CID,
                    "SelectedOption": selectedNo,
                    "SelectedAmmount": selectedNo == 1 ? selectedValue : 0,
                    "CoverageCost": selectedNo == 1 ? ((selectedValue / 1000) * currentTarrifRate) : 0,
                    "CustomerSign": customerSign,
                    "IsTab": customerInfoState?.IsTab,
                    "DeductibleAmount": customerInfoState?.IsDeductible ? customerInfoState?.DeductibleAmount : 0,
                    "SignDate": signCDate?.toString().split(" ")[1],
                    "SignTime": signCDate?.toString().split(" ")[2] + " " + signCDate?.toString().split(" ")[3],
                }
            }
        }

        console.log("saveFVPValue 4option params::", params);

        try {
            const endPoint = `${process.env.REACT_APP_API_ENDPOINT}/saveFVPValue`;
            await fetch(endPoint, {
                method: 'POST',
                headers: {
                    'x-api-key': `${process.env.REACT_APP_FVP_API_KEY_DEV}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
            })
                .then(response => response.json())
                .then(async (data) => {
                    console.log(data);
                    setLoading(false);
                    if (data == true) {
                        await getCustomerDetail(customerInfoState?.customerId);
                        navigate(templateProps?.nextScreen || '/');
                    } else {
                        alert("Data is not saved.");
                    }
                });
        } catch (error) {
            console.error('ERROR:', error);
            setLoading(false);
        }
    }

    const updateSelectionbkp = async (CID: any) => {
        console.log("customerInfoState:", customerInfoState)
        const abc = customerInfoState?.IsDeductible ? customerInfoState?.DeductibleAmount : 0;
        const isWeightDetuctible = customerInfoState?.IsWeightDeductible;
        let params = {};

        if (isWeightDetuctible) {
            params = {
                "CustomerId": CID,
                "SelectedOption": selectedNo,
                "SelectedAmmount": ownValue,
                "CoverageCost": ownCoverageCost.toFixed(2),
                "CustomerSign": customerSign,
                "IsTab": customerInfoState?.IsTab,
                "DeductibleAmount": 0
            }
        } else {
            params = {
                "CustomerId": CID,
                "SelectedOption": selectedNo,
                "SelectedAmmount": selectedNo == 1 ? selectedValue : 0,
                "CoverageCost": selectedNo == 1 ? ((selectedValue / 1000) * currentTarrifRate) : 0,
                "CustomerSign": customerSign,
                "IsTab": customerInfoState?.IsTab,
                "DeductibleAmount": customerInfoState?.IsDeductible ? customerInfoState?.DeductibleAmount : 0
            }
        }

        console.log("updateSelection::", params);

        try {
            const endPoint = `${process.env.REACT_APP_API_ENDPOINT}/saveFVPValue`;
            await fetch(endPoint, {
                method: 'POST',
                headers: {
                    'x-api-key': `${process.env.REACT_APP_FVP_API_KEY_DEV}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
            })
                .then(response => response.json())
                .then(async (data) => {
                    console.log(data);
                    setLoading(false);
                    if (data == true) {
                        await getCustomerDetail(customerInfoState?.customerId);
                        navigate(templateProps?.nextScreen || '/');
                    } else {
                        alert("Data is not saved.");
                    }
                });
        } catch (error) {
            console.error('ERROR:', error);
            setLoading(false);
        }
    }

    const CustomerSignBlock = (idx: number) => {
        return <div style={{ paddingTop: 32, clear: "both" }}>
            {customerInfoState?.IsTab != 2 ?
                <div>
                    <SignatureCard
                        title={templateProps?.signCard?.title || ""}
                        signRef={customerSignRef}
                        onEnd={handleCustomerSignEnd}
                        onBegin={() => { setInvalidCustomerSignMessage(""); }}
                        sign={customerSign || ""}
                        populate={signatures?.getUrl ? true : false}
                        handleClearClick={clearCustomerSignature}
                        signHere={templateProps?.signCard?.signHere || `${customerInfoState?.CustomerName} SIGN HERE`}
                        // signDate={customerSign ? `SIGNED ${moment(signDate).format('DD/MM/YY HH:mm A')}` : ""}
                        // signDate={signatures?.getUrl ? `SIGNED ${moment(new Date(customerInfoState?.SignedDated)).format('MM/DD/YY HH:mm A')}` :
                        //     customerSign ? `SIGNED ${moment(signDate).format('MM/DD/YY HH:mm A')}` : ""}
                        signDate={signCDate}
                    />
                    <div className='color-red fw-500 mb-30 mt-8'>{invalidCustomerSignMessage}</div>
                    <div>
                        {
                            customerSign && <Button
                                onClick={handleContinue}
                                color="primary"
                                variant="contained"
                                // disabled={loading || idx == customerInfoState.FVPOption || (idx == selectedNo && !customerSign)}
                                // disabled={loading || ((selectedNo == 1 || selectedNo == 3) && (errorMsg.length == 0 ? false : true))}
                                //disabled={loading || (selectedNo == 1 || selectedNo == 3) && ((weightObject[selectedNo].errorMsg.length == 0 && errorMsg.length == 0) ? false : true)}
                                disabled={loading || (weightObject[selectedNo].errorMsg.length == 0 && errorMsg.length == 0 && deductibleObject[selectedNo].errorMsg.length == 0) ? false : true}
                                size="large"
                                text={"CONTINUE"}
                            //disabled={loading || isDisbaleContinue()}
                            />
                        }
                    </div>
                </div>
                :
                <div>
                    <Button
                        onClick={handleContinue}
                        color="primary"
                        variant="contained"
                        disabled={loading || (weightObject[selectedNo].errorMsg.length == 0 && errorMsg.length == 0 && deductibleObject[selectedNo].errorMsg.length == 0) ? false : true}
                        size="large"
                        text={"CONTINUE"}
                    />
                </div>
            }
        </div>
    }

    const handleChange = (event: { target: { value: string } }) => {
        // @ts-ignore
        setSelectedValue(event.target.value);
    };

    const handleDeductibleDDLChange = (event: { target: { value: string } }, sno: number) => {
        const val = event.target.value;

        let deductibleObj = [...deductibleObject];
        console.log("VAL:", val, deductibleObj[sno].minimumValue, val < deductibleObj[sno].minimumValue)
        if (val < deductibleObj[sno].minimumValue) {
            deductibleObj[sno].errorMsg = `Value cannot be selected less than minimum value (${deductibleObj[sno].minimumValue}).`;
            //alert(`Minimum value is ${deductibleObj[sno].minimumValue}`)
            //return;
        } else {
            deductibleObj[sno].errorMsg = "";
            // @ts-ignore
            setSelectedValue(val);
        }
        deductibleObj[sno].selectedValue = val;
        setDeductibleObject(deductibleObj);
    };

    const handleDeselectOption = (sno: number) => {
        clearCustomerSignature();
        if (selectedNo == sno) {
            SetSelectedNo(-1);
        } else {
            SetSelectedNo(sno);
        }
    }
    function allowChars(charValue: any) {
        const acceptedKeys = '0123456789';
        return acceptedKeys.indexOf(charValue) > -1;
    }
    // function handleKeyPress(e: any) {
    //     const key = e.key;
    //     const max = maxOwnAmtAmt;
    //     const min = 7200;
    //     console.log("cc:", allowChars(key));
    //     if (!allowChars(key)) {
    //         console.log("Not Allowed:", key);
    //         e.preventDefault();
    //     } else {
    //         let val = e.target.value;
    //         val = val + +key;
    //         console.log("Allowed:", key, val, ownValue, val > max);
    //         if (val > max) {
    //             e.target.value = e.target.value.slice(0, e.target.value.length - 1);

    //             return;
    //         }
    //         setOwnValue(e.target.value)
    //     }
    // }

    const validateOwnAmount = (val: number, sno: number, weightObj: any) => {
        let currentOption = weightObj[sno];

        if (currentOption) {
            if (val > currentOption.maxOwnAmtAmt) {
                currentOption.errorMsg = `Value cannot be more than ${maxOwnAmtAmt}`
            } else if (val < currentOption.minAmt) {
                currentOption.errorMsg = `Value cannot be less than ${currentOption.minAmt}`
            } else {
                currentOption.errorMsg = ""
            }
        }

        weightObj[sno].errorMsg = currentOption.errorMsg;
        setWeightObject(weightObj);
    }
    const handleOwnCoverageCost = (event: any, sno: number) => {
        let weightObj = [...weightObject];
        weightObj[sno][event.target.name] = event.target.value;
        calculateWeightOwnCoverageCost(sno);
        validateOwnAmount(event.target.value, sno, weightObj);
    };

    const renderZeroDetuctibleBlock = ({ dropdown, recommendedInfo }: any) => {
        return <div className="connditionalBlock">
            <div className="conditionalBlockChild">
                <div style={{
                    marginBottom: 8
                }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                        <DynamicHtml content={dropdown?.label} />
                    </Typography></div>
                <div>
                    <Select labelId="label" className="selectMenuBlock" value={selectedValue} onChange={(e: any) => handleChange(e)}>
                        {dropdown?.data?.map((dropItem: any, idx: number) => {
                            return <MenuItem key={idx} value={dropItem?.value} style={{
                                display: "flex", justifyContent: "space-between", alignContent: "center"
                            }}>{dropItem?.label} {selectedValue == dropItem?.value && <span className="checkMarkActive" style={{ float: "right", lineHeight: 0.8, color: "rgba(11, 154, 100, 1)" }}><CustomIcon iconName="check" size="small" /></span>}</MenuItem>
                        })}
                    </Select>
                    {/* <span className="errorMessage"></span> */}
                </div>
            </div>
            <div className="conditionalBlockChild">
                <div style={{
                    marginBottom: 8
                }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                        <DynamicHtml content={recommendedInfo?.sectionLabel} />
                    </Typography></div>
                <div><Typography variant='h5' color='textPrimary' className="title" noWrap={false} align='center'>
                    <DynamicHtml content={"$" + coverageCost} />
                </Typography></div>
            </div>
        </div>
    }

    const renderDetuctibleBlock = ({ dropdown, recommendedInfo, deductible, sno }: any) => {
        return <div>
            <div className="connditionalBlock">
                <div className="conditionalBlockChild">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={deductible?.deductibleDDLLabel} />
                        </Typography></div>
                    <div>
                        <Select labelId="label" className="selectMenuBlock" value={deductibleObject[sno]?.selectedValue} onChange={(e: any) => handleDeductibleDDLChange(e, sno)}>
                            {dropdown?.data?.map((dropItem: any, idx: number) => {
                                return <MenuItem key={idx} value={dropItem?.value} style={{
                                    display: "flex", justifyContent: "space-between", alignContent: "center"
                                }}>{dropItem?.label} {deductibleObject[sno]?.selectedValue == dropItem?.value && <span className="checkMarkActive" style={{ float: "right", lineHeight: 0.8, color: "rgba(11, 154, 100, 1)" }}><CustomIcon iconName="check" size="small" /></span>}</MenuItem>
                            })}
                        </Select>
                    </div>
                </div>

                <div className="conditionalBlockChild">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={deductible?.deductibleSectionLabel} />
                        </Typography></div>
                    <div><Typography variant='h5' color='textPrimary' className="title" noWrap={false} align='center'>
                        <DynamicHtml content={"$" + deductible.deductibleAmount} />
                    </Typography></div>
                </div>
            </div>
            <div className="errorMessage" style={{ marginBottom: 10, marginTop: 0 }}>{deductibleObject[sno].errorMsg}</div>

            <div className="conditionalBlockChild">
                <div style={{
                    marginBottom: 8
                }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                        <DynamicHtml content={deductible.deductiblePremiumAmountLabel} />
                    </Typography>
                </div>
                <div className="conditionalBlockChild">
                    <Typography variant='h5' color='textPrimary' className="title" noWrap={false} align='center'>
                        <DynamicHtml content={"$" + deductibleObject[sno]?.coverageCost} />
                    </Typography>
                </div>

            </div>
        </div>
    }

    const renderWeightDetuctibleBlock = ({ recommendedInfo, weightDetuctible, sno }: any) => {
        console.log("hhh", weightObject[sno])
        return <div>
            <div className="connditionalBlock" style={{ display: 'flex', alignItems: 'start' }}>
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8,
                        textAlign: 'left'
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} >
                            <DynamicHtml content={weightDetuctible?.weightLabel} />
                        </Typography>
                        <Typography variant='caption' color='textPrimary' className="title" noWrap={false} style={{ fontSize: '10px' }} >
                            <DynamicHtml content={weightDetuctible?.weightSubLabel} />
                        </Typography>
                    </div>
                    <div>
                        <TextField className="inputStyle" variant="outlined" defaultValue={weightDetuctible?.actualWeight + " lbs"} multiline={false} disabled={true} />
                    </div>
                </div>
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={weightDetuctible?.weightCoverageLabel} />
                        </Typography>
                        <Typography variant='caption' color='textPrimary' className="title" noWrap={false} style={{ fontSize: '10px' }} >
                            <DynamicHtml content={"&nbsp;"} />
                        </Typography>
                    </div>
                    <div><Typography variant='h5' color='textPrimary' className="amountSection" noWrap={false} align='center'>
                        <DynamicHtml content={"$" + weightDetuctible.weightCoverageCost} />
                    </Typography></div>

                </div>
            </div>
            <fieldset className="fieldSetStyle">
                <legend>OR</legend>
            </fieldset>
            <div className="connditionalBlock">
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8, textAlign: 'left'
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} >
                            <DynamicHtml content={weightDetuctible?.ownValueLabel} />
                        </Typography></div>
                    <div>
                        <TextField name={`ownValue`} style={{ border: 'solid 1px gray' }}
                            className="inputStyle" variant="outlined" defaultValue={weightObject[sno]?.ownValue} multiline={false}
                            type="number"
                            onChange={(e) => handleOwnCoverageCost(e, sno)}
                        />
                        <span className="errorMessage">{weightObject[sno]?.errorMsg}</span>
                    </div>
                </div>
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={weightDetuctible?.coverageCostLabel} />
                        </Typography></div>
                    <div><Typography variant='h5' color='textPrimary' className="amountSection" noWrap={false} align='center'>
                        <DynamicHtml content={"$" + weightObject[sno]?.ownCoverageCost?.toFixed(2)} />
                    </Typography></div>
                </div>
            </div>
        </div>
    }

    const renderWeightDetuctibleBlockBKP = ({ recommendedInfo, weightDetuctible, sno }: any) => {
        return <div>
            <div className="connditionalBlock" style={{ display: 'flex', alignItems: 'start' }}>
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8,
                        textAlign: 'left'
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} >
                            <DynamicHtml content={weightDetuctible?.weightLabel} />
                        </Typography>
                        <Typography variant='caption' color='textPrimary' className="title" noWrap={false} style={{ fontSize: '10px' }} >
                            <DynamicHtml content={weightDetuctible?.weightSubLabel} />
                        </Typography>
                    </div>
                    <div>
                        <TextField className="inputStyle" variant="outlined" defaultValue={weightDetuctible?.actualWeight + " lbs"} multiline={false} disabled={true} />
                    </div>
                </div>
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={weightDetuctible?.weightCoverageLabel} />
                        </Typography>
                        <Typography variant='caption' color='textPrimary' className="title" noWrap={false} style={{ fontSize: '10px' }} >
                            <DynamicHtml content={"&nbsp;"} />
                        </Typography>
                    </div>
                    <div><Typography variant='h5' color='textPrimary' className="amountSection" noWrap={false} align='center'>
                        <DynamicHtml content={"$" + weightDetuctible.weightCoverageCost} />
                    </Typography></div>

                </div>
            </div>
            <fieldset className="fieldSetStyle">
                <legend>OR</legend>
            </fieldset>
            <div className="connditionalBlock">
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8, textAlign: 'left'
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} >
                            <DynamicHtml content={weightDetuctible?.ownValueLabel} />
                        </Typography></div>
                    <div>
                        <TextField name={`ownValue${sno}`}
                            className="inputStyle" variant="outlined" defaultValue={ownValue} multiline={false}
                            type="number"
                            onChange={(e) => handleOwnCoverageCost(e, sno)}
                        />
                        <span className="errorMessage">{errorMsg}</span>
                    </div>
                </div>
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={weightDetuctible?.coverageCostLabel} />
                        </Typography></div>
                    <div><Typography variant='h5' color='textPrimary' className="amountSection" noWrap={false} align='center'>
                        <DynamicHtml content={"$" + ownCoverageCost.toFixed(2)} />
                    </Typography></div>
                </div>
            </div>
        </div>
    }
    function dataURItoBlob(dataURI: any) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type: 'image/png' });
    }

    const uploadSignature = async (sign?: any) => {
        try {
            let imageURL = customerSign;
            const blob = dataURItoBlob(imageURL)
            var signature = new File([blob], "");
            const requestOptions: any = {
                method: "PUT",
                body: signature,
                redirect: "follow",
            };

            //const custInfo: any = JSON.parse(localStorage.getItem('customerInfo') || "");
            // let geturl = custInfo?.Signatureurl[0].getUrl || "";
            // let endPoint: any = custInfo?.Signatureurl[0].putUrl || "";

            let geturl = customerInfoState?.Signatureurl[0].getUrl || "";
            let endPoint: any = customerInfoState?.Signatureurl[0].putUrl || "";

            if (!endPoint) {
                setLoading(false);
                return false
            }

            //let endPoint: any = "https://bol-application-dev.s3.amazonaws.com/signatures/7054279/FVP?AWSAccessKeyId=AKIA437WX7QEP6ZIFKZJ&Expires=1682688600&Signature=fURvEqWdSgJgqjJ3RC5BYMbs5i0%3D";
            return uploadSignatureWithRetry(endPoint, requestOptions, 1);

        } catch (e) {
            debugger;
            console.log(e);
            setLoading(false);
        }
        return false
    }

    const uploadSignatureWithRetry: any = async (endPoint: any, requestOptions: any, noOfRetries: number) => {
        const retryLimit = noOfRetries + 1;

        return await fetch(endPoint, requestOptions)
            .then(async (response: any) => {
                console.log("response:", response)
                if (response?.ok) {
                    updateSelection(customerInfoState?.customerId)
                } else {
                    console.log("upload failed. so retrying again");
                    if (retryLimit <= 3) {
                        return uploadSignatureWithRetry(endPoint, requestOptions, retryLimit);
                    } else {
                        console.log("Max Retries limit for upload is reached");
                    }
                }
                setLoading(false);
                return response;
            })
    }

    const getCustomerDetail = async (CID: any) => {
        try {
            setLoading(true);
            const endPoint = `${process.env.REACT_APP_API_ENDPOINT}/getCustomerDetails`;
            await fetch(endPoint, {
                method: 'POST',
                headers: {
                    'x-api-key': `${process.env.REACT_APP_FVP_API_KEY_DEV}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "CustomerId": CID
                })
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    localStorage.setItem("customerInfo", JSON.stringify(data));
                    dispatch({
                        'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
                        'payload': { ...data, "customerId": localStorage.getItem('CID') }
                    })
                    setLoading(false);
                });
        } catch (error) {
            console.error('ERROR:', error);
            setLoading(false);
        }
    }
    //console.log("MovingProtection customerInfoState:", customerInfoState);

    const renderAMSProtectionPlan = (item: any) => {
        if (item?.sno == 1 || item?.sno == 3) {
            if (item.isDeductible) {
                return renderDetuctibleBlock(item)
            } else if (item.isWeightDetuctible) {
                return renderWeightDetuctibleBlock(item)
            } else {
                return renderZeroDetuctibleBlock(item)
            }
        }
    }

    // console.log("selectedNo:", selectedNo, "tariffRate:", data[selectedNo]?.tariffRate, "minAmt:", minAmt, "maxOwnAmtAmt:", maxOwnAmtAmt, "errorMsg:", errorMsg);
    //console.log("weightObject:", weightObject);
    // console.log("selectedNo:", selectedNo, "tariffRate:", data[selectedNo]?.tariffRate);
    // console.log("detuctibleObjSelected:", deductibleObject);
    console.log("weightObject:", weightObject);
    return (<div className='full-block movingProtection'>
        {/* <Header backNav={true} progressValue={0} /> */}
        <div className="outlineContainer">
            <div className="baseContainerBlock">
                <div><TitleBlock title={title} subtitle={subtitle} /></div>
                <div>
                    {data?.map((item: any, idx: number) => {
                        return <div key={idx} id={"option_" + item?.sno} className={item?.isRecommended ? "protectionRec" : ""} style={{
                            width: "100%", float: "left"
                        }}>
                            <Cards variant="default">
                                {item?.isRecommended && <Typography variant="overline" variantMapping={{ subtitle2: "span" }} className="protectTag">
                                    {"Recommended"}
                                </Typography>}
                                <div>
                                    <Title title={item?.title} subtitle={item?.subtitle || ""} />
                                </div>
                                {item?.isRecommended && <div style={{
                                    paddingTop: 8, paddingBottom: 16, clear: "both"
                                }}><Typography variant="subtitle2" variantMapping={{ subtitle2: "span" }} className="popularOption">
                                        {item?.recommendedInfo?.highlightInfo}
                                    </Typography></div>}
                                <div>
                                    <Typography color='textPrimary' noWrap={false} align='center' className="protectionContent">
                                        {
                                            item.sno == 2 && selectedNo == 2 ?
                                                <DynamicHtml content={item?.selectedContent} />
                                                : <DynamicHtml content={item?.content} />
                                        }

                                    </Typography>
                                </div>
                                <div>
                                    {
                                        renderAMSProtectionPlan(item)
                                    }
                                </div>

                                <div className='selectBtnCn protectionBtnCntnr'>
                                    <div>
                                        <Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                                            <DynamicHtml content={item?.recommendedInfo?.footer} />
                                        </Typography>
                                    </div>
                                    <div style={{
                                        textAlign: "right"
                                    }}>
                                        <Button
                                            onClick={() => handleDeselectOption(item?.sno)}
                                            color="primary"
                                            variant="outlined"
                                            endIcon={selectedNo == item?.sno ? "check" : ""}
                                            text={selectedNo == item?.sno ? "SELECTED" : "SELECT"}
                                        >
                                        </Button>
                                    </div>
                                </div>

                                {selectedNo == item?.sno && CustomerSignBlock(item?.sno)}
                            </Cards>
                        </div>
                    })}
                </div>
            </div>
        </div>
    </div>)
}

export default MovingProtection